<template>
  <div>
    <div class="modifica-dati-partner" v-if="!isFetching">
      <h3>{{ labels.modifica_dati_partner }}</h3>
      <div class="corpo-modifica-dati-partner">
        <b-form-row class="b-form-row">
          <b-col sm="12" md="12" lg="4" xl="4">
            <b-form-group v-bind:label="labels.codice">
              <b-form-input
                :size="size"
                class="b-form-input"
                id="codice"
                v-model="dati_partner.codice"
                maxlength="45"
                readonly
              ></b-form-input>
              <p
                class="errore"
                id="errore-codice"
                v-if="isError(errori.codice)"
              >
                {{ labels_errori[errori.codice] }}
              </p>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="12" lg="8" xl="8">
            <b-form-group v-bind:label="labels.descrizione">
              <b-form-input
                :size="size"
                class="b-form-input"
                id="descrizione"
                v-model="dati_partner.descrizione"
                maxlength="45"
              ></b-form-input>
              <p
                class="errore"
                id="errore-descrizione"
                v-if="isError(errori.descrizione)"
              >
                {{ labels_errori[errori.descrizione] }}
              </p>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-form-row class="b-form-row">
          <b-col sm="12" md="6" lg="6" xl="6">
            <b-form-group class="b-form-group" v-bind:label="labels.password">
              <b-form-input
                :size="size"
                class="b-form-input"
                id="password"
                v-model="dati_partner.password"
                maxlength="45"
                type="password"
                autocomplete="off"
              ></b-form-input>
              <p
                class="errore"
                id="errore-password"
                v-if="isError(errori.password)"
              >
                {{ labels_errori[errori.password] }}
              </p>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" lg="6" xl="6">
            <b-form-group
              class="b-form-group"
              v-bind:label="labels.conferma_password"
            >
              <b-form-input
                :size="size"
                class="b-form-input"
                id="conferma-password"
                v-model="conferma_password"
                maxlength="45"
                type="password"
                autocomplete="off"
              ></b-form-input>
              <p
                class="errore"
                id="errore-conferma-password"
                v-if="isError(errori.conferma_password)"
              >
                {{ labels_errori[errori.conferma_password] }}
              </p>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-form-row class="b-form-row">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-form-group class="b-form-group" v-bind:label="labels.email">
              <b-form-input
                :size="size"
                class="b-form-input"
                id="email"
                v-model="dati_partner.email"
                maxlength="255"
                type="text"
              ></b-form-input>
              <p class="errore" id="errore-email" v-if="isError(errori.email)">
                {{ labels_errori[errori.email] }}
              </p>
            </b-form-group>
          </b-col>
        </b-form-row>

        <br />
        <b-form-row class="b-form-row" style="text-align: center; width: 100%">
          <b-col sm="12" md="12" lg="12" xl="12" style="width: 100%">
            <b-button
              style="width: 100%"
              variant="success"
              @click="invia"
              :disabled="invio_in_corso"
              >{{ labels.invia }}</b-button
            >
            <div class="errore" id="errore-invia" v-if="isError(errori.invia)">
              <br />
              {{ labels_errori[errori.invia] }}
              <br />
              <br />
            </div>
          </b-col>
        </b-form-row>
        <br />
      </div>

      <br />
      <b-form-row class="b-form-row">
        <b-col sm="12" md="12" lg="12" xl="12">
          <strong>{{ labels.file_logo }}</strong>
          <br />
          <p style="text-align: justify">{{ labels.descrizione_file_logo }}</p>
          <div id="frame-file-logo">
            <img
              id="picture-file-logo"
              style="border-style: solid; border-color: orange"
              :src="nome_file_logo1"
              fluid
              alt="File logo"
              v-if="dati_partner.nome_file_logo != ''"
            />
            <div
              id="picture-file-logo2"
              style="
                height: 90px;
                border-style: solid;
                border-color: orange;
                display: block;
              "
              v-if="dati_partner.nome_file_logo == ''"
            ></div>
          </div>
          <br />
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="8" md="8" lg="8" xl="8">
          <b-form-group class="b-form-group">
            <b-form-file
              accept="image/*"
              v-bind:label="labels.file_logo"
              v-model="file_logo"
              :state="Boolean(file_logo)"
              :browse-text="labels.testo_pulsante_browse"
              :placeholder="labels.scegli_un_file"
              :drop-placeholder="labels.trascina_un_file_qui"
            ></b-form-file>
          </b-form-group>
        </b-col>
        <b-col sm="4" md="4" lg="4" xl="4">
          <b-form-group class="b-form-group">
            <b-button
              variant="warning"
              style="width: 100%"
              @click="spedisci_logo"
              :disabled="invio_in_corso"
              >{{ labels.invia_logo }}</b-button
            >
          </b-form-group>
        </b-col>
      </b-form-row>
    </div>
  </div>
</template>

<script>
import store from "@/store/index";
import router from "@/router/index";
import { utility } from "@/utility";
const axios = require("axios");

export default {
  name: "ModificaDatiPartner",
  data() {
    return {
      labels: {},
      labels_errori: {},
      errori: {},
      dati_partner: {
        codice: "",
        descrizione: "",
        password: "",
        email: "",
        lingua: "",
        nome_file_logo: "",
      },
      conferma_password: "",
      size: "sm",
      file_logo: null,
      nome_file_logo1: "",
      isFetching: true,
      contatore: 0,
      event_resize: null,
      invio_in_corso: false,
    };
  },
  components: {},
  mixins: [utility],
  methods: {
    scambia_file_logo() {
      this.nome_file_logo1 =
        this.$store.state.ServerURL +
        "LOGHI/PARTNERS/" +
        this.dati_partner.nome_file_logo +
        "?t=" +
        Date.now();
    },

    invia() {
      try {
        if (!fn_ControllaDati(this)) {
          return;
        }

        let me = this;

        let parametri = {
          utente_collegato: this.$store.state.Utente,
          password_utente_collegato: this.$store.state.Password,
          dati_partner: {
            codice: this.dati_partner.codice,
            descrizione: this.dati_partner.descrizione,
            password: this.dati_partner.password,
            email: this.dati_partner.email,
            lingua: this.$store.state.Lingua,
          },
        };
        let parametri_json = JSON.stringify(parametri);

        let ServerURL = this.$store.state.ServerURL;
        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "post",
          url: ServerURL + "CheckIn/AggiornaPartner",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              me.$root.$children[0].$refs.ApplicationAlert.show(
                me.labels.aggiornamento_effettuato
              );
            } else if (response.data.errore == -2) {
              me.registraErrore(
                response.data.esito,
                "ModificaDatiPartner-invia"
              );
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "ModificaDatiPartner-invia");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "ModificaDatiPartner-invia");
      }
    },

    spedisci_logo() {
      if (this.file_logo == null) {
        return;
      }

      let me = this;
      let ServerURL = this.$store.state.ServerURL;
      let formData = new FormData();
      formData.append("file", this.file_logo);
      fn_CambiaCursore("wait", this);
      this.invio_in_corso = true;

      axios
        .post(
          ServerURL +
            "CheckIn/UploadFile?nome_file=" +
            this.file_logo.name +
            "&tipo=P" +
            "&codice=" +
            this.$store.state.Utente,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(function (response) {
          me.invio_in_corso = false;
          fn_CambiaCursore("default", me);
          if (response.data.errore == 0) {
            me.dati_partner.nome_file_logo =
              response.data.oggetto.nome_file_logo;
            me.scambia_file_logo();

            me.$bvModal
              .msgBoxOk(me.labels.file_logo_inviato, {
                title: me.labels.conferma_invio,
              })
              .then(function () {
                fn_RidimensionaLogo();
              });
          } else if (response.data.errore == -2) {
            me.registraErrore(
              response.data.esito,
              "ModificaDatiPartner-spedisci_logo"
            );
          } else {
            me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
              title: me.labels_errori.si_e_verificato_un_errore,
              bodyClass: "errore",
            });
          }
        })
        .catch(function (error) {
          me.invio_in_corso = false;
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "ModificaDatiPartner-spedisci_logo");
        });
    },
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  mounted() {},
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);

      window.onresize = function () {
        fn_RidimensionaLogo();
      };

      let me = this;

      let parametri = {
        utente_collegato: this.$store.state.Utente,
        password_utente_collegato: this.$store.state.Password,
        codice: this.$store.state.Utente,
      };
      let parametri_json = JSON.stringify(parametri);

      let ServerURL = this.$store.state.ServerURL;
      fn_CambiaCursore("wait", this);

      axios({
        method: "post",
        url: ServerURL + "CheckIn/LeggiPartner",
        data: parametri_json,
      })
        .then(function (response) {
          fn_CambiaCursore("default", me);
          if (response.data.errore == 0) {
            me.dati_partner = response.data.oggetto;
            me.conferma_password = response.data.oggetto.password;
            me.$store.state.Lingua = response.data.oggetto.lingua;

            me.scambia_file_logo();

            me.isFetching = false;

            me.$nextTick(function () {
              fn_RidimensionaLogo();
            });
          } else if (response.data.errore == -2) {
            me.registraErrore(
              response.data.esito,
              "ModificaDatiPartner-created"
            );
          } else {
            me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
              title: me.labels_errori.si_e_verificato_un_errore,
              bodyClass: "errore",
            });
          }
        })
        .catch(function (error) {
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "ModificaDatiPartner-created");
        });
    } catch (error) {
      this.registraErrore(error, "ModificaDatiPartner-created");
    }
  },
  beforeDestroy() {
    window.onresize = null;
  },
  beforeRouteEnter(to, from, next) {
    try {
      let UtenteAutenticato = store.state.UtenteAutenticato;
      let UtentePartner = store.state.UtentePartner;
      if (
        (to.meta.requiresAuth && !UtenteAutenticato) ||
        (to.meta.is_partner && !UtentePartner)
      ) {
        router.push("/menupartner/permessiinsufficienti", null, function () {});
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      modifica_dati_partner: "Modifica dati partner",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      password: "Password",
      conferma_password: "Conferma password",
      invia: "Invia",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      file_logo: "File del logo",
      descrizione_file_logo:
        "Il file verrà usato come intestazione delle email o altri documenti. Si consiglia di creare un'immagine che risulti ben proporzionata nel riquadro sottostante (dimensioni 650x90 pixel o multipli).",
      testo_pulsante_browse: "Cerca",
      scegli_un_file: "Scegli un file o trascina un file qui",
      trascina_un_file_qui: "Trascina un file qui",
      invia_logo: "Invia file logo",
      file_logo_inviato: "File di logo inviato con successo",
      conferma_invio: "Conferma invio",
    };
    let labels_inglese = {
      modifica_dati_partner: "Modifica dati partner",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      password: "Password",
      conferma_password: "Conferma password",
      invia: "Invia",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      file_logo: "File del logo",
      descrizione_file_logo:
        "Il file verrà usato come intestazione delle email o altri documenti. Si consiglia di creare un'immagine che risulti ben proporzionata nel riquadro sottostante (dimensioni 650x90 pixel o multipli).",
      testo_pulsante_browse: "Cerca",
      scegli_un_file: "Scegli un file o trascina un file qui",
      trascina_un_file_qui: "Trascina un file qui",
      invia_logo: "Invia file logo",
      file_logo_inviato: "File di logo inviato con successo",
      conferma_invio: "Conferma invio",
    };
    let labels_tedesco = {
      modifica_dati_partner: "Modifica dati partner",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      password: "Password",
      conferma_password: "Conferma password",
      invia: "Invia",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      file_logo: "File del logo",
      descrizione_file_logo:
        "Il file verrà usato come intestazione delle email o altri documenti. Si consiglia di creare un'immagine che risulti ben proporzionata nel riquadro sottostante (dimensioni 650x90 pixel o multipli).",
      testo_pulsante_browse: "Cerca",
      scegli_un_file: "Scegli un file o trascina un file qui",
      trascina_un_file_qui: "Trascina un file qui",
      invia_logo: "Invia file logo",
      file_logo_inviato: "File di logo inviato con successo",
      conferma_invio: "Conferma invio",
    };
    let labels_francese = {
      modifica_dati_partner: "Modifica dati partner",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      password: "Password",
      conferma_password: "Conferma password",
      invia: "Invia",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      file_logo: "File del logo",
      descrizione_file_logo:
        "Il file verrà usato come intestazione delle email o altri documenti. Si consiglia di creare un'immagine che risulti ben proporzionata nel riquadro sottostante (dimensioni 650x90 pixel o multipli).",
      testo_pulsante_browse: "Cerca",
      scegli_un_file: "Scegli un file o trascina un file qui",
      trascina_un_file_qui: "Trascina un file qui",
      invia_logo: "Invia file logo",
      file_logo_inviato: "File di logo inviato con successo",
      conferma_invio: "Conferma invio",
    };

    let labels_errori_italiano = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      codice_non_trovato: "Codice non trovato",
      password_non_coincidenti: "Password non coicidenti",
      nessun_file_inviato: "Nessun file di logo inviato",
      partner_non_trovato: "Partner non trovato",
    };
    let labels_errori_inglese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      codice_non_trovato: "Codice non trovato",
      password_non_coincidenti: "Password non coicidenti",
      nessun_file_inviato: "Nessun file di logo inviato",
      partner_non_trovato: "Partner non trovato",
    };
    let labels_errori_tedesco = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      codice_non_trovato: "Codice non trovato",
      password_non_coincidenti: "Password non coicidenti",
      nessun_file_inviato: "Nessun file di logo inviato",
      partner_non_trovato: "Partner non trovato",
    };
    let labels_errori_francese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      codice_non_trovato: "Codice non trovato",
      password_non_coincidenti: "Password non coicidenti",
      nessun_file_inviato: "Nessun file di logo inviato",
      partner_non_trovato: "Partner non trovato",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "ModificaDatiPartner-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};
    if (vm.dati_partner.codice.trim() == "") {
      vm.errori.codice = "dato_obbligatorio";
      esito = false;
    }
    if (vm.dati_partner.descrizione.trim() == "") {
      vm.errori.descrizione = "dato_obbligatorio";
      esito = false;
    }
    if (vm.dati_partner.email.trim() == "") {
      vm.errori.email = "dato_obbligatorio";
      esito = false;
    } else {
      let pattern = vm.$store.state.PatternEmail;

      if (!pattern.test(vm.dati_partner.email)) {
        vm.errori.email = "indirizzo_email_non_valido";
        esito = false;
      }
    }
    if (vm.dati_partner.password.trim() == "") {
      vm.errori.password = "dato_obbligatorio";
      esito = false;
    } else {
      if (vm.dati_partner.password.trim() != vm.conferma_password.trim()) {
        vm.errori.password = "password_non_coincidenti";
        esito = false;
      }
    }

    if (esito) {
      return true;
    } else {
      vm.errori.invia = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "ModificaDatiPartner-fn_ControllaDati");
  }
}

function fn_RidimensionaLogo() {
  let elemento = document.getElementById("frame-file-logo");
  if (elemento == null) {
    return;
  }
  let larghezza = elemento.offsetWidth;
  if (larghezza > 652) {
    larghezza = 652;
  }

  elemento = document.getElementById("picture-file-logo");
  if (elemento == undefined) {
    elemento = document.getElementById("picture-file-logo2");
  }

  elemento.style.width = larghezza.toString() + "px";
  elemento.style.height = ((larghezza * 90) / 652).toString() + "px";
}
function fn_CambiaCursore(cursore) {
  document.querySelector("body").style.cursor = cursore;
}
</script>

<style scoped>
.modifica-dati-partner {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 4px;
  padding: 20px;
}
</style>
